import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'jafar-company-widget',
  templateUrl: './company-widget.component.html',
  styleUrls: ['./company-widget.component.scss']
})
export class CompanyWidgetComponent {
  router = inject(Router)

  buttonClicked(){
    this.router.navigateByUrl("managecip/companies")
  }
}
